import { getFieldValue } from "../booking-instruments/helpers";

const LinkedInstanceRender = (params) => {
  const linkedInstance = getFieldValue(params?.data, "linked_instance");
  return <>{linkedInstance || ''}</>;
};

export default LinkedInstanceRender;
